import React from 'react';
import './DeleteCoupen.css';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';

const DeleteCoupen = ({ isOpen, onClose, onConfirm, coupenName = 'this coupon' }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-coupen-overlay">
      <div className="delete-coupen-modal">
        <div className="delete-coupen-header">
          <h2>Delete Coupon</h2>
          <button className="delete-coupen-close-button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="delete-coupen-content">
          <div className="delete-coupen-icon">
            <ClearIcon sx={{ color: '#DC2626', fontSize: 32 }} />
          </div>

          <p className="delete-coupen-message">
            Are you sure you want to delete "<span className="coupen-title-text">{coupenName}</span>
            "?
            <br />
            This action cannot be undone.
          </p>
        </div>

        <div className="delete-coupen-actions">
          <button className="delete-coupen-cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="delete-coupen-delete-button" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCoupen;
